/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useAppContext } from 'providers/AppProvider';
import ReturnFilter from './ReturnFilter';
import ReturnTable from './ReturnTable';
import styles from './return.module.scss';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const returnBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'reports',
    url: '/reports/purchase/invoice'
  },

  {
    label: 'return',
    active: true
  }
];

const ReportReturn = () => {
  const { t, i18n } = useTranslation();
  const {
    config: { theme }
  } = useAppContext();

  const barcodeInputRef = useRef<HTMLInputElement>(null);

  const [generateTableData, setGeneratedTableData] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getName, setGetName] = useState('');
  const [getBarcode, setGetBarcode] = useState('');
  const [getFilterData, setGetFilterData] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedBarcode, setDebouncedBarcode] = useState('');
  const [totalAmount, setTotalAmount] = useState([]);
  const [labeledVisibleFields, setLabeledVisibleFields] = useState<any>('');

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
      setTimeout(() => barcodeInputRef.current?.select(), 500);
    }
  }, []);

  return (
    <div>
      <PageBreadcrumb items={returnBreadcrumbItems} />
      <div className="d-flex gap-2 align-items-center mb-5">
        <h2>{t('return')}</h2>
        <ButtonRefresh
          onRefresh={() => {
            queryClient.refetchQueries('GET_REPORTS_REMAINING');
          }}
        />
      </div>
      <ReturnFilter
        setGeneratedTableData={setGeneratedTableData}
        savedValues={savedValues}
        setSavedValues={setSavedValues}
        setGetFilterData={setGetFilterData}
        getName={getName}
        setGetName={setGetName}
        setGetBarcode={setGetBarcode}
        barcodeInputRef={barcodeInputRef}
        setCurrentPage={setCurrentPage}
        setDebouncedBarcode={setDebouncedBarcode}
        getBarcode={getBarcode}
        currentPage={currentPage}
        setPageCount={setPageCount}
        getFilterData={getFilterData}
        setTotalAmount={setTotalAmount}
        labeledVisibleFields={labeledVisibleFields}
      />

      <ReturnTable
        generateTableData={generateTableData}
        setGeneratedTableData={setGeneratedTableData}
        getName={getName}
        getBarcode={getBarcode}
        getFilterData={getFilterData}
        savedValues={savedValues}
        setTotalAmount={setTotalAmount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageCount={pageCount}
        setPageCount={setPageCount}
        // barcodeInputRef={barcodeInputRef}
        debouncedBarcode={debouncedBarcode}
        setLabeledVisibleFields={setLabeledVisibleFields}
      />

      <div
        className={
          theme === 'dark' ? styles.darkFooterRemain : styles.footerRemain
        }
      >
        {totalAmount && (
          <div
            className={styles.box}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            {totalAmount?.map((items: any) => (
              <div key={items} className="d-flex gap-2">
                <p className="mb-0" style={{ fontWeight: '800' }}>
                  {t('total_amount_receipts')}: (
                  {items?.currency?.name?.[i18n?.language]})
                </p>
                <span style={{ fontWeight: '800' }}>
                  {items?.total_price_in_amount
                    ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 4,
                        useGrouping: true
                      })
                        .format(items?.total_price_in_amount)
                        .replace(/,/g, ' ')
                    : 0}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportReturn;
